var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-box"},[_c('v-head'),_vm._v(" "),_c('div',{staticClass:"main-content"},[_c('div',{staticClass:"content-box",class:{'content-collapse':_vm.collapse}},[_c('router-view')],1)]),_vm._v(" "),_c('v-foot')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fafbab6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Home.vue
// module id = null
// module chunks = 